const brightcovePlayers = {
    firestorePath: 'config/default/brightcovePlayers',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'brightcovePlayers',
    statePropName: 'data',
    namespaced: true, // automatically added
  
    // this object is your store module (will be added as '/myModule')
    // you can also add state/getters/mutations/actions
    state: {
    },
    getters: {
      array: state => Object.values(state.data),
      obj: state => state.data,
      byId: (state) => (id) => {
        return state.data[id]
      },

    },
    mutations: {},
    actions: {},
  }
  
  export default brightcovePlayers